import { AutoComplete } from "antd";
import { useDebounce } from "core/features/shared/useDebouce";
import { PaginateResult } from "core/resources/types/shared";
import { UseQueryResult } from "react-query";
import { Input } from "@chakra-ui/input";
import { Spinner } from "@chakra-ui/react";

export interface InputAutocompleteProps {
  textValue: string | undefined;
  onType: (v: string | undefined) => any;
  onSelect: (v: string | undefined) => any;
  placeholder?: string;
  useDataHook: (
    search?: string
  ) => UseQueryResult<PaginateResult<{ id: string; nome: string }>, unknown>;
}

function InputAutocomplete({
  textValue,
  onType,
  onSelect,
  placeholder = "Procurar",
  useDataHook,
}: InputAutocompleteProps) {
  const debouncedValue = useDebounce(textValue, 50);
  const { data, isLoading, isFetching } = useDataHook(debouncedValue);

  const items =
    data?.items.map((item) => ({
      value: item.id,
      label: item.nome,
    })) || [];

  const _isLoading = isLoading || isFetching;

  return (
    <AutoComplete
      value={textValue}
      onChange={(v) => {
        onType(v);
        onSelect(undefined);
      }}
      allowClear
      onClear={() => {
        onType(undefined);
        onSelect(undefined);
      }}
      options={items}
      onSelect={(_, option) => {
        onSelect(option.value);
        onType(option.label as string);
      }}
      bordered={false}
      backfill={false}
      clearIcon={_isLoading ? <Spinner ml={-1.5} mt={-1.5} /> : undefined}
      style={{
        width: "100%",
      }}
    >
      <Input placeholder={placeholder} pr="48px" />
    </AutoComplete>
  );
}

export default InputAutocomplete;
